var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("會員等級管理")]), _c('div', {
    staticClass: "row mx-0 justify-content-between mb-2 mt-3"
  }, [_c('div', [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ['collapse-filter', 'collapse-search'],
      expression: "['collapse-filter', 'collapse-search']"
    }],
    attrs: {
      "variant": "outline-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-magnify"
  }), _vm._v("進階搜尋 ")])], 1), _c('div', [_vm.$permissions.has(_vm.$permissions.consts.CUSTOMER_LEVEL_BATCH_RECOMPUTE) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.recomputeLevel
    }
  }, [_c('i', {
    staticClass: "mdi mdi-flask-outline"
  }), _vm._v("會員等級即時運算 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.CUSTOMER_LEVEL_CREATE) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'CustomerLevelsCreate'
      }
    }
  }, [_vm._v(" 新增會員等級 ")]) : _vm._e()], 1)]), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-filter"
    }
  }, [_c('b-card', [_c('b-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('b-form-group', {
    staticClass: "mr-2 mb-2",
    attrs: {
      "label": "生效狀態"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.isProcessingOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.is_processing,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_processing", $$v);
      },
      expression: "query.is_processing"
    }
  })], 1), _c('b-form-group', {
    staticClass: "mr-2 mb-2",
    attrs: {
      "label": "啟用狀態"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.isEnableOptions
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_enabled", $$v);
      },
      expression: "query.is_enabled"
    }
  })], 1)], 1)], 1)], 1), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-search"
    }
  }, [_c('b-card', [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "max-width": "500px"
    },
    attrs: {
      "placeholder": "搜尋名字、描述"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.levels,
      "fields": _vm.fields,
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(is_default)",
      fn: function fn(data) {
        return [data.item.is_default ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('i', {
          staticClass: "mdi mdi-check"
        })]) : _vm._e()];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerLevelsEdit',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_vm._v(_vm._s(_vm.hiddenString(data.item.name, 20)))])];
      }
    }, {
      key: "cell(logo_url)",
      fn: function fn(data) {
        return [data.item.logo_url ? _c('b-img-lazy', {
          staticClass: "mx-2 thumb-image level-image",
          attrs: {
            "src": data.item.logo_url,
            "alt": "等級圖",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(card_picture_url)",
      fn: function fn(data) {
        return [data.item.card_picture_url ? _c('b-img-lazy', {
          staticClass: "thumb-image level-image",
          attrs: {
            "src": data.item.card_picture_url,
            "alt": "會員卡底圖",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(start_to_end)",
      fn: function fn(data) {
        return [_c('p', [_vm._v(" " + _vm._s(_vm.convertTimeStyle(data.item.start_at)) + " "), data.item.start_at && data.item.end_at ? _c('a', [_vm._v(" / ")]) : _vm._e()]), _c('p', [_vm._v(_vm._s(_vm.convertTimeStyle(data.item.end_at)))])];
      }
    }, {
      key: "cell(is_processing)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.item.is_processing ? 'success' : 'danger'
          }
        }, [_vm._v(" " + _vm._s(data.item.is_processing ? "生效中" : "已失效") + " ")])];
      }
    }, {
      key: "cell(is_enabled)",
      fn: function fn(data) {
        return [_c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": !!data.item.is_enabled === true ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(!!data.item.is_enabled === true ? "啟用" : "停用"))])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.CUSTOMER_LEVEL_LIST]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'CustomerLevelsCustomerList',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-account-multiple"
        }), _vm._v(" 會員列表")]) : _vm._e(), _vm.checkPermissionAny([_vm.consts.CUSTOMER_LEVEL_AUTO_CHANGE_VIEW, _vm.consts.CUSTOMER_LEVEL_AUTO_CHANGE_EDIT]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'CustomerLevelRuleList',
              query: {
                level_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-settings"
        }), _vm._v(" 規則設定")]) : _vm._e(), _vm.checkPermission([_vm.consts.CUSTOMER_LEVEL_EDIT]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'CustomerLevelsView',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看")]) : _vm._e(), _vm.checkPermission([_vm.consts.CUSTOMER_LEVEL_EDIT]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'CustomerLevelsEdit',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯")]) : _vm._e(), _c('span', {
          staticClass: "d-inline-block",
          attrs: {
            "id": "delete-btn-".concat(data.item.id)
          }
        }, [_vm.checkPermission([_vm.consts.CUSTOMER_LEVEL_DELETE]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger",
            "disabled": data.item.is_default || data.item.customers_count > 0
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除")]) : _vm._e()], 1), data.item.is_default ? _c('b-tooltip', {
          attrs: {
            "target": "delete-btn-".concat(data.item.id),
            "placement": "bottom"
          }
        }, [_vm._v(" 預設會員等級無法刪除 ")]) : data.item.customers_count > 0 ? _c('b-tooltip', {
          attrs: {
            "target": "delete-btn-".concat(data.item.id),
            "placement": "bottom"
          }
        }, [_vm._v(" 此等級內已存在會員，無法刪除，請整批移轉會員後再進行刪除 ")]) : _vm._e()];
      }
    }])
  })], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }